module.exports = __webpack_public_path__ + "static/media/footer_logo.964c13ca.png";